import { CookieConsentSettingState } from '@as-react/common-types';
import { CookieConsentActionTypes } from '../../../enums/ActionEnums';
export const initialCookieConsentState = {
    cookieConsentSettingAvailable: CookieConsentSettingState.OLD_COMPONENT,
};
export const cookieConsentReducer = (initialData) => {
    const initialReducerState = Object.assign(Object.assign({}, initialCookieConsentState), initialData);
    return (state = initialReducerState, action) => {
        switch (action.type) {
            case CookieConsentActionTypes.CLEAR:
                return {
                    cookieConsentSettingAvailable: CookieConsentSettingState.NO_CONSENTS_AVAILABLE,
                };
            case CookieConsentActionTypes.SET:
                return Object.assign(Object.assign({}, state), {
                    cookieConsentSettingAvailable: action.payload
                        ? CookieConsentSettingState.CONSENTS_AVAILABLE
                        : CookieConsentSettingState.NO_CONSENTS_AVAILABLE,
                    cookieConsentSettings: action.payload,
                });
            default:
                return state;
        }
    };
};
